import React from 'react';

const EmailSent = ({ submittedEmail, returnLogin, setIsSubmitted }) => {
    return (
        <div className="login_content_right_box_width">
            <div className="login_box">
                <div className="login_box_header p-t20" style={{ justifyContent: "center", flexDirection: "column" }}>
                    <div className="login_box_txt">驗證信寄送成功!</div>
                    <div className='form_message'></div>
                    <div className="login_box_txt">系統已產生一組新密碼並寄送到您的email信箱</div>
                    <div className="login_box_txt">{submittedEmail}</div>
                    <button className='blue_common_button'
                        onClick={returnLogin}
                    >我已收到</button>
                    <button className='blue_common_button_reverse'
                        onClick={() => setIsSubmitted(false)}
                    >沒收到信件?</button>
                </div>
            </div>
        </div>
    );
}

export default EmailSent;
